import type { ModelId } from "@/lib/ai/models";

export const HIGH_TIER_MODEL_IDS = [
  "claude-opus-5-5",
  "gemini-3.1-pro-preview",
  "gpt-6-astra",
  "gpt-6-sol",
] as const satisfies readonly ModelId[];

const HIGH_TIER_MODEL_ID_SET = new Set<ModelId>(HIGH_TIER_MODEL_IDS);

export function isHighTierModelId(modelId: ModelId) {
  return HIGH_TIER_MODEL_ID_SET.has(modelId);
}
